export default __webpack_public_path__ + "static/media/MaleIcon.26d62273.svg";